import styled from '@emotion/styled';
import StrapiImage from '@lib/image/strapiImage';
import { usePageContext } from '@lib/pimster-stories/contexts/PageContext';
import {
    useProgressContext,
    useProgressDispatchContext,
} from '@lib/pimster-stories/contexts/ProgressContext';
import { SanitizedStoryPage } from '@lib/pimster-stories/types';
import { getStrapiAssetUrl } from '@lib/strapi';
import { FC, useEffect } from 'react';

export const IMAGE_STORY_PAGE_DURATION = 5;

type Props = { storyPage: SanitizedStoryPage };

const ImageContainer = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: hidden;
`;

const ImageWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
`;

const SStrapiImage = styled(StrapiImage)`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

const Image: FC<Props> = ({ storyPage }) => {
    const { currentPageIndex } = useProgressContext();
    const dispatch = useProgressDispatchContext();
    const { pageIndex } = usePageContext();

    useEffect(() => {
        if (currentPageIndex === pageIndex) {
            dispatch({
                type: 'START',
                payload: {
                    duration: IMAGE_STORY_PAGE_DURATION,
                    isInfinite: storyPage.looping,
                },
            });
        }
    }, [storyPage, currentPageIndex, pageIndex, dispatch]);

    return (
        <ImageContainer>
            <ImageWrapper>
                <SStrapiImage
                    src={getStrapiAssetUrl(storyPage.media)!}
                    formats={storyPage.media.formats}
                    alt={storyPage.subtitle}
                    sizes='100vw'
                />
            </ImageWrapper>
        </ImageContainer>
    );
};

export default Image;
